import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function TerminalPage() {
  return <AppPagePlaceholder name="Terminal" />;
}
